export const CONTENT_BLOCK_TYPENAME_PREFIX = 'com.hubspot.aviator.agent.message.content.chirp.';
export const ABLY_TYPE_TO_CHIRP_SUFFIX = {
  TEXT: 'TextChirpContentBlock',
  TOOL_USE: 'ToolUseChirpContentBlock',
  TOOL_RESULT: 'ToolResultChirpContentBlock',
  THINKING: 'ThinkingChirpContentBlock',
  IMAGE: 'ImageChirpContentBlock',
  IMAGE_TOOL_RESULT: 'ImageToolResultChirpContentBlock',
  SERVER_TOOL_USE: 'ServerToolUseChirpContentBlock',
  PENDING_TOOL_RESULT: 'PendingToolResultChirpContentBlock',
  REDACTED_THINKING: 'RedactedThinkingChirpContentBlock',
  DISPLAY_ONLY: 'DisplayOnlyChirpContentBlock',
  CONTEXT: 'ContextChirpContentBlock',
  FILE: 'FileChirpContentBlock',
  PDF: 'PdfChirpContentBlock',
  AGENT_CONFIG: 'AgentConfigChirpContentBlock',
  TOOL_APPROVAL_REQUEST: 'ToolApprovalRequestChirpContentBlock'
};
export const TOOL_USE_BLOCK_TYPES = new Set(['TOOL_USE', 'SERVER_TOOL_USE']);